module.exports = __webpack_public_path__ + "img/white-arrow.85931216.svg";